module.exports = {
      id: "ic-placeholder-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-placeholder-usage",
      toString: function () {
        return this.url;
      }
    }